import { render, staticRenderFns } from "./product_attr.vue?vue&type=template&id=2958c337"
import script from "./product_attr.vue?vue&type=script&lang=js"
export * from "./product_attr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports